<template>
    <div>
        <GmapMap :center="center" :zoom="zoom" style="width:100%;  height: 1000px;">
            <gmap-marker
                :key="index"
                v-for="(m, index) in getMarkers"
                :position="m"
                :icon="m.iconColor"
                :clickable="true"
                @mouseover="getShowPinData ? openWindow(m, index) : null"
            ></gmap-marker>

            <gmap-info-window
                @closeclick="window_open = false"
                :opened="window_open"
                :position="infoPosition"
                :options="infoOptions"
            ></gmap-info-window>
        </GmapMap>
    </div>
</template>

<script>
export default {
    name: 'GoogleMap',
    props: {
        zoom: {
            type: Number,
            default: 4
        },
        showPinData: {
            type: Boolean,
            default: true
        },
        lat: {
            type: Number,
            default: -23.458582
        },
        lng: {
            type: Number,
            default: -46.437963
        },
        listData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            yellow: require('@/assets/yellow-mark.svg'),
            blue: require('@/assets/blue-mark.svg'),
            pink: require('@/assets/pink-mark.svg'),
            center: { lat: 0, lng: 0 },
            markers: [],
            infoPosition: null,
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                },
                maxWidth: 200,
                content: null
            },
            window_open: false,
            currentMidx: null
        }
    },
    methods: {
        getColorMarker(data) {
            if (data.id_organizacao === 1 && data.prestador_servico === 0) {
                // iniciativa
                return this.pink
            } else if (data.id_organizacao === 1 && data.prestador_servico) {
                // prestador
                return this.yellow
            } else if (data.id_organizacao === 2) {
                // investidor
                return this.blue
            }
        },
        getPosition: function(marker) {
            return {
                lat: parseFloat(marker.lat),
                lng: parseFloat(marker.lng)
            }
        },
        openWindow(marker, idx) {
            this.infoPosition = this.getPosition(marker)

            this.infoOptions.content = `
                <div>
                    <div style="color: #000;">
                        <h6>${marker.label}</h6>

                        <div>Cidade: ${marker.city}</div>
                    </div>
                </div>`

            if (this.currentMidx === idx) {
                this.window_open = !this.window_open
            } else {
                this.window_open = true
                this.currentMidx = idx
            }
        }
    },
    computed: {
        getMarkers() {
            return this.listData.map(item => ({
                lat: Number(item.latitude),
                lng: Number(item.longitude),
                label: item.organizacao,
                city: item.cidade,
                iconColor: this.getColorMarker(item)
            }))
        },
        getShowPinData() {
            return this.showPinData
        }
    },
    mounted() {
        this.center.lat = -14.3645139
        this.center.lng = -57.9003397
    }
}
</script>



// WEBPACK FOOTER //
// src/ui/google-map/GoogleMap.vue